import { Skeleton, Typography } from '@mui/material';
import { Span } from '../ThreatCard/ThreatCard.shared.style';
import { HorizontalLine } from '../../pages/ThreadsDetails/Style/SingleThreat.style';
import { SectionColumn, SectionTitle, InfoRow, InfoLabel } from '../ThreatTable/ThreatExpandedRow.style';
import { formatedDate } from '../../utils';

interface DomainInfoField {
  value: string | undefined;
  loading?: boolean;
}

interface ExpandedDomainInfoProps {
  ssl: DomainInfoField;
  registrar: DomainInfoField;
  registered: DomainInfoField;
  expires: DomainInfoField;
}

const FieldValue = ({ field, isDate }: { field: DomainInfoField; isDate?: boolean }) => {
  if (field.loading) return <Skeleton variant="text" width={80} />;
  if (field.value) return <>{isDate ? `${formatedDate(field.value)} UTC` : field.value}</>;
  return <Span>No data available</Span>;
};

const ExpandedDomainInfo = ({ ssl, registrar, registered, expires }: ExpandedDomainInfoProps) => (
  <SectionColumn>
    <SectionTitle>Domain Info</SectionTitle>
    <HorizontalLine sx={{ mb: 1 }} />

    <InfoRow>
      <InfoLabel>SSL:</InfoLabel>
      <Typography variant="body2">
        <FieldValue field={ssl} />
      </Typography>
    </InfoRow>

    <InfoRow>
      <InfoLabel>Registrar:</InfoLabel>
      <Typography variant="body2">
        <FieldValue field={registrar} />
      </Typography>
    </InfoRow>

    <InfoRow>
      <InfoLabel>Registered:</InfoLabel>
      <Typography variant="body2">
        <FieldValue field={registered} isDate />
      </Typography>
    </InfoRow>

    <InfoRow>
      <InfoLabel>Expires:</InfoLabel>
      <Typography variant="body2">
        <FieldValue field={expires} isDate />
      </Typography>
    </InfoRow>
  </SectionColumn>
);

export default ExpandedDomainInfo;
